// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"81a232f0","422":"9e1c732a","455":"2db99844","645":"a1dee96e","977":"1a647242"}[chunkId] + ".chunk.js";
};